export const environment = {
  apiBaseUrl: 'https://docsign-api-dev.excelhire.com/api/v1',
};
